import { useState } from "react";
import { useDebounce } from "use-debounce";
import { SpinnerLegacy } from "../../../components";
import { Alert } from "../../../components/alert/Alert";
import { InfiniteList } from "../../../components/infiniteLoading/InfiniteList";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { useSupplierRelationshipList } from "../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipList";
import { NewConnectionCommentLink } from "./NewConnectionCommentLink";
import { NewConnectionConnectionDialogSearchInput } from "./NewConnectionConnectionDialogSearchInput";

export const SupplierNewConnectionCommentThreadDialogContent = ({
  setDialogActive,
}: {
  setDialogActive: (active: boolean) => void;
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue] = useDebounce(searchValue, 500);

  const supplierRelationshipListQuery = useSupplierRelationshipList({
    query: [
      {
        type: "connectionType",
        modifier: "EQUALS",
        value: "customer",
      },
    ],
    limit: 10,
    search: debouncedSearchValue,
  });

  return (
    <div>
      {supplierRelationshipListQuery.isError ? (
        <Alert
          type={"error"}
          message={
            apiV2AssertError(supplierRelationshipListQuery.error)?.response
              ?.data.message ?? "Unknown error"
          }
        />
      ) : (
        <InfiniteList query={supplierRelationshipListQuery}>
          <NewConnectionConnectionDialogSearchInput
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
          {supplierRelationshipListQuery.isLoading ? (
            <SpinnerLegacy />
          ) : (
            supplierRelationshipListQuery.data?.pages.map((page) =>
              page.map((connection) => (
                <NewConnectionCommentLink
                  key={connection.id}
                  relationshipId={connection.RelationshipId}
                  setActive={setDialogActive}
                  business={connection.Buyer.Business}
                />
              )),
            )
          )}
        </InfiniteList>
      )}
    </div>
  );
};
